import React from "react";
import { Tag, Printer } from "lucide-react";
import { Btn } from "@/components/UI";
import { previewPdf, printPdf } from "@/lib/pdfActions";

const READY = ["approved", "partial", "completed"];

// 10×10 kargo etiketi — sipariş onaylandığı andan itibaren (sevkiyattan bağımsız) yazdırılabilir.
export function LabelButtons({ orderId, soNo, status, size, testid = "label", withPrint = false }) {
  const ok = READY.includes(status);
  const path = `/sales-orders/${orderId}/shipping-label.pdf`;
  const name = `Kargo_Etiketi_${soNo}.pdf`;
  const tip = ok ? "10×10 kargo etiketi" : "Sipariş onaylandıktan sonra aktif olur";
  return (
    <>
      <Btn size={size} variant="secondary" disabled={!ok} title={tip} onClick={() => previewPdf(path, name)} data-testid={`${testid}-${orderId}`}>
        <Tag size={12} /> Kargo Etiketi
      </Btn>
      {withPrint && (
        <Btn size={size} variant="secondary" disabled={!ok} title={tip} onClick={() => printPdf(path, name)} data-testid={`${testid}-print-${orderId}`}>
          <Printer size={12} /> Etiketi Yazdır
        </Btn>
      )}
    </>
  );
}
